import React from 'react';
import {
  Box,
  Chip,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
  makeStyles,
} from '@material-ui/core';
import { InsertDriveFile as FileIcon } from '@material-ui/icons';
import PropTypes from 'prop-types';
import { useFormState } from 'react-final-form';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius,
    padding: theme.spacing(1),
    backgroundColor: theme.palette.background.paper,
  },
  list: {
    maxHeight: 200,
    overflow: 'auto',
  },
  listItem: {
    padding: theme.spacing(0.5),
  },
  emptyState: {
    color: theme.palette.text.secondary,
    fontStyle: 'italic',
    padding: theme.spacing(1),
  },
  chip: {
    marginRight: theme.spacing(0.5),
    marginBottom: theme.spacing(0.5),
  },
}));

const getFileKey = (file) => {
    // Use file ID if available
    if (file?.id) return `file-${file.id}`;
    
    // Use file name + last modified for File objects
    if (file instanceof File) return `file-${file.name}-${file.lastModified}`;
    
    // Fallback to a simple hash of the file name
    const fileName = file?.name || file?.nome || 'unknown';
    let hash = 0;
    for (let i = 0; i < fileName.length; i+=i) {
      const char = fileName.charCodeAt(i);
      hash = ((hash * 31) + char) % 1000000000; 
    }
    return `file-${hash}-${fileName.replace(/[^a-z0-9]/gi, '-')}`;
  };

const QCXFileListDisplay = ({
  variant = 'list', 
  emptyText = 'Nenhum arquivo selecionado',
  fileNameGetter = (file) => file?.name || file?.nome || 'Arquivo sem nome',
}) => {
  const classes = useStyles();
  const { values } = useFormState({ subscription: { values: true }});
  const documentoPagamento = values?.documentoPagamento || [];

  if (!documentoPagamento || (Array.isArray(documentoPagamento) && documentoPagamento.length === 0)) {
    return (
      <Box className={classes.root}>
        <Typography variant="body2" className={classes.emptyState}>
          {emptyText}
        </Typography>
      </Box>
    );
  }

  const fileArray = Array.isArray(documentoPagamento) ? documentoPagamento : [documentoPagamento];

  if (variant === 'chips') {
    return (
      <Box className={classes.root}>
        {fileArray.map((file) => (
          <Chip
            key={getFileKey(file)}
            icon={<FileIcon fontSize="small" />}
            label={fileNameGetter(file)}
            className={classes.chip}
            variant="outlined"
          />
        ))}
      </Box>
    );
  }

  return (
    <Box className={classes.root}>
      <List dense className={classes.list}>
        {fileArray.map((file) => (
          <ListItem key={getFileKey(file)} className={classes.listItem}>
            <ListItemIcon>
              <FileIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText
              primary={fileNameGetter(file)}
              primaryTypographyProps={{ variant: 'body2' }}
            />
          </ListItem>
        ))}
      </List>
    </Box>
  );
};

QCXFileListDisplay.propTypes = {
  variant: PropTypes.oneOf(['list', 'chips']),
  emptyText: PropTypes.string,
  fileNameGetter: PropTypes.func,
};

export default QCXFileListDisplay;